<app-datatable
  [dataSource]="jobSource"
  [columns]="columns"
  [baseColumns]="baseColumns"
  [identifier]="'jobs'"
  [actionNew]="false"
  [customActions]="customActions"
  [customTableActions]="customTableActions"
  [filterElements]="filterElements"
  [filtersBesideSearch]="true"
  [loadOnInit]="true"
  [columnConfigurationEnabled]="true"
  [customFieldOptions]="customFieldOptions"
  [searchPlaceholder]="'job.search-by-name'"
  (columnConfigurationChanged)="onColumnConfigurationChanged($event)"
  (showEvent)="show($event.valueOf())"
>
  <app-empty-table [icon]="'work'" [emptyText]="'job.empty_text' | translate">
  </app-empty-table>
</app-datatable>
<app-error [error]="error"></app-error>

<ng-template #exportModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'job.export' | translate }}</h4>
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label>{{ 'dataconnection.singular' | translate }}</label>
        <app-input-with-error
          [control]="connectionControl"
          inputType="select"
          [selectDefaultText]="'job.export_select_hint' | translate"
          [selectValues]="connectionValues"
          [selectNames]="connectionNames"
          [translateSelect]="false"
        ></app-input-with-error>
      </div>
    </form>
    <div class="form-group">
      <label>{{ 'job.export_range' | translate }}</label>
      <p-datepicker
        required
        [(ngModel)]="dateRange"
        [ngModelOptions]="{ standalone: true }"
        selectionMode="range"
        dateFormat="dd.mm.yy"
        [showIcon]="true"
        [showButtonBar]="true"
        [numberOfMonths]="1"
        styleClass="w-100"
        inputStyleClass="w-100"
      />
    </div>
    <div class="form-group mt-3">
      <label>{{ 'job.export_status' | translate }}</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="complete"
          [formNoValidate]="true"
        />
        <label class="form-check-label">{{ 'COMPLETE' | translate }}</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="deleted"
          skipValidation
        />
        <label class="form-check-label">{{ 'DELETED' | translate }}</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="cancelled"
          skipValidation
        />
        <label class="form-check-label">{{ 'CANCELLED' | translate }}</label>
      </div>
    </div>
    <div class="form-group mt-3">
      <label>{{ 'job.export_config' | translate }}</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="addWorker"
          [formNoValidate]="true"
        />
        <label class="form-check-label">{{
          'job.export_add_worker' | translate
        }}</label>
      </div>
    </div>
  </div>
  <app-error class="ms-3 me-3" [error]="modalError"></app-error>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modalRef?.close()"
    >
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="export()"
      [ladda]="loading"
    >
      {{ 'export' | translate }}
    </button>
  </div>
</ng-template>
